<template>
  <div style="width: 100%;height: 100%;overflow:auto;">
    <el-select v-model="area" style="width: 150px;margin-top: 10px;margin-left: 10px" @change="initData">
      <el-option v-for="area in areaList" :key="area.code" :label="area.name" :value="area.code"></el-option>
    </el-select>

    <div style="width: 98%;height: 300px;" id="yearRankingChart"></div>

  </div>

</template>

<script>

import * as echarts from "echarts";

export default {
  name: "YearRanking",

  data(){
    return{
      area:'',
      areaList:[],
      rankingSeriesData:[],
      xLengthData:[],

    }
  },
  async created(){
    await this.getAreaList();
    await this.initData();

  },
  methods: {

    async initData(){
      await this.getRankingData();
      await this.renderEcharts();
    },

    async getRankingData(){
      let data = await this.$http('crmAgentService.getYearRankingData',{area:this.area});
      this.rankingSeriesData = data?.rankingSeriesData;
      this.xLengthData = data?.xLengthData;
    },

    async getAreaList(){
      this.areaList = await this.$http('crmAgentService.getAreaList');
      if(this.areaList.length > 0){
        this.areaList.push({code:'all',name:'全国'})
        this.area = this.areaList[0].code;
      }
    },

    renderEcharts() {

      const yearRankingChartDom = document.getElementById('yearRankingChart');

      // 获取现有的 ECharts 实例（如果有）
      let yearRankingChart = echarts.getInstanceByDom(yearRankingChartDom);
      // 如果存在现有的实例，销毁它
      if (yearRankingChart) {
        yearRankingChart.dispose();
      }
      // 初始化新的 ECharts 实例
      yearRankingChart = echarts.init(yearRankingChartDom);
      yearRankingChart.setOption(this.getYearRankingChartOptions(), true);
    },
    getYearRankingChartOptions() {
      return {
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          top: '10px',
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: this.xLengthData === undefined ? [] : this.xLengthData
        },
        yAxis: {
          name: '排名',
          type: 'value',
          //inverse: true,
        },
        series: this.rankingSeriesData === undefined ? [] : this.rankingSeriesData
      }
    },
  }
}
</script>

<style scoped>

</style>